import { render, staticRenderFns } from "./FacilityPhotos.vue?vue&type=template&id=7970b921&scoped=true&"
import script from "./FacilityPhotos.vue?vue&type=script&lang=js&"
export * from "./FacilityPhotos.vue?vue&type=script&lang=js&"
import style0 from "./FacilityPhotos.vue?vue&type=style&index=0&id=7970b921&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7970b921",
  null
  
)

export default component.exports